import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import de from './locales/de.json'
import en from './locales/en.json'
import hr from './locales/hr.json'

export const LOCALES = ['hr', 'de', 'en'] as const
export type AppLocale = (typeof LOCALES)[number]

const STORAGE_KEY = 'trasaflow.lang'

export function isLocale(value: unknown): value is AppLocale {
  return typeof value === 'string' && (LOCALES as readonly string[]).includes(value)
}

function readStored(): AppLocale | null {
  try {
    const value = localStorage.getItem(STORAGE_KEY)
    return isLocale(value) ? value : null
  } catch {
    return null
  }
}

/** Standard: gespeicherte Wahl, sonst Deutsch im Dev und Kroatisch in Produktion (Pilot HR). */
export function defaultLocale(): AppLocale {
  return readStored() ?? (import.meta.env.DEV ? 'de' : 'hr')
}

export function setLocale(locale: AppLocale): void {
  try {
    localStorage.setItem(STORAGE_KEY, locale)
  } catch {
    // Speicher gesperrt (z. B. privater Modus): Sprache gilt dann nur für diese Sitzung.
  }
  void i18n.changeLanguage(locale)
}

/** Nutzersprache aus /me übernehmen, solange keine eigene Wahl gespeichert ist. */
export function applyUserLocale(locale: string | undefined): void {
  if (readStored() === null && isLocale(locale) && i18n.language !== locale) {
    void i18n.changeLanguage(locale)
  }
}

export const resources = {
  de: { translation: de },
  hr: { translation: hr },
  en: { translation: en },
}

void i18n.use(initReactI18next).init({
  resources,
  lng: defaultLocale(),
  fallbackLng: 'en',
  supportedLngs: [...LOCALES],
  interpolation: { escapeValue: false },
  returnNull: false,
})

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng
})
document.documentElement.lang = i18n.language

export default i18n
